export function show(el:HTMLElement):void {
	el.classList.remove("shacc-hide");
}

export function hide(el:HTMLElement):void {
	el.classList.add("shacc-hide");
}